import { auth } from "./firebase";

export type DraftResponse = {
  draft: {
    story_en: string;
    story_zh: string;
    analysis_en: string;
    analysis_zh: string;
    learning_outcomes_en: string;
    learning_outcomes_zh: string;
    what_next_en: string;
    what_next_zh: string;
    evaluation_en: string;
    evaluation_zh: string;
    eylf_codes: string[];
  };
  prior_report_id: string | null;
};

export async function generateDraft(args: {
  reportId: string;
  pickerAccessToken: string;
}): Promise<DraftResponse> {
  const apiUrl = import.meta.env.VITE_DRAFT_API_URL;
  if (!apiUrl) throw new Error("VITE_DRAFT_API_URL not configured");
  const idToken = await auth.currentUser?.getIdToken();
  if (!idToken) throw new Error("Not signed in");

  const res = await fetch(`${apiUrl}/draft`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      report_id: args.reportId,
      picker_access_token: args.pickerAccessToken,
    }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText })) as { error?: string };
    throw new Error(body.error ?? `Draft API ${res.status}`);
  }
  return res.json() as Promise<DraftResponse>;
}
